export default {
  defaultImage: 'https://via.placeholder.com/100/100',
  backgroundWhiteImage: 'http://dev.efan-gateway.doublepoint.com.ar/storage/products-service/images/white-image.png',
  appName: 'BilleteraFAN',
};
